import React from "react";

import gql from "graphql-tag";
import { Query } from '@apollo/client/react/components';
import LoadingView from "./LoadingView";
import ErrorView from "./ErrorView";

import Button from "react-bootstrap/Button";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import { Link } from "react-router-dom";

const MAX_PROCESSES = 500;

const GET_PROCESSES_SUMMARY = gql`
  query ocrProcesses($limit: Int, $state: String = "") {
    ocrProcesses(limit: $limit, state: $state) {
      processNumber
      state
      patient
      sum
      submittedOn
      submittedOnTimestamp
    }
  }
`;

function stateToIcon(state: string) {
  if (state === "offen") {
    return "icon-mail-open";
  }

  if (state === "eingereicht") {
    return "icon-mail";
  }

  if (state === "erstattet") {
    return "icon-euro";
  }

  if (state === "einspruch") {
    return "icon-attention-1";
  }

  if (state === "abgeschlossen") {
    return "icon-ok-circled";
  }

  // TODO: Replace with Gavel
  return "icon-minus-squared";
}

export default class RPaketTable extends React.Component<any> {
  state: {
    filter: string;
    sortOrder: string;
    sortKey: string;
    limit: number;
  };

  constructor(props: any) {
    super(props);

    this.state = {
      filter: "",
      sortOrder: "desc",
      sortKey: "number",
      limit: 25,
    };
  }

  switchSort(column: string) {
    if (this.state.sortKey === column) {
      if (this.state.sortOrder === "asc") {
        this.setState({ ...this.state, sortOrder: "desc" });
      } else {
        this.setState({ ...this.state, sortOrder: "asc" });
      }
    } else {
      this.setState({ ...this.state, sortOrder: "asc", sortKey: column });
    }
  }

  sortProcesses(processes: any) {
    let sortFn: any = null;

    if (this.state.sortKey === "status") {
      sortFn = (a: any, b: any) => {
        if (a.state < b.state) {
          return -1;
        }
        if (a.state > b.state) {
          return 1;
        }
        return 0;
      };
    } else if (this.state.sortKey === "number") {
      sortFn = (a: any, b: any) => {
        if (a.processNumber < b.processNumber) {
          return -1;
        }
        if (a.processNumber > b.processNumber) {
          return 1;
        }
        return 0;
      };
    } else if (this.state.sortKey === "patient") {
      sortFn = (a: any, b: any) => {
        if (a.patient < b.patient) {
          return -1;
        }
        if (a.patient > b.patient) {
          return 1;
        }
        return 0;
      };
    } else if (this.state.sortKey === "sum") {
      sortFn = (a: any, b: any) => {
        if (a.sum < b.sum) {
          return -1;
        }
        if (a.sum > b.sum) {
          return 1;
        }
        return 0;
      };
    } else {
      sortFn = (a: any, b: any) => {
        if (a.submittedOnTimestamp < b.submittedOnTimestamp) {
          return -1;
        }
        if (a.submittedOnTimestamp > b.submittedOnTimestamp) {
          return 1;
        }
        return 0;
      };
    }

    let sortFnOrd: any = sortFn;
    if (this.state.sortOrder === "desc") {
      sortFnOrd = (a: any, b: any) => sortFn(b, a);
    }

    return processes.slice().sort(sortFnOrd);
  }

  render() {
    let content: any = undefined;

    return (
      <Query
        query={GET_PROCESSES_SUMMARY}
        variables={{ limit: this.state.limit, state: this.state.filter }}
        partialRefetch={true}
      >
        {({ loading, error, data, refetch }: any) => {
          if (loading) {
            return <LoadingView />;
          }
          if (error) {
            return <ErrorView error={error} />;
          }

          if (this.props.children) {
            content = this.props.children;
          } else if (data.ocrProcesses.length < this.state.limit) {
            content = (
              <div className="centered-message">Keine weiteren Vorgänge</div>
            );
          } else if (this.state.limit === MAX_PROCESSES) {
            content = (
              <div className="centered-message">
                Limit erreicht. Zeige keine weiteren Vorgänge.
              </div>
            );
          } else {
            content = (
              <div
                style={{
                  marginLeft: "30%",
                  marginRight: "30%",
                  width: "40%",
                }}
              >
                <Button
                  variant="light"
                  onClick={() => {
                    this.setState({
                      ...this.state,
                      limit: this.state.limit + 10,
                    });
                    refetch({
                      variables: {
                        limit: this.state.limit,
                        state: this.state.filter,
                      },
                    });
                  }}
                >
                  Weitere Vorgänge laden
                </Button>
              </div>
            );
          }

          return (
            <>
              <ButtonGroup
                size="sm"
                className="mr-2"
                style={{
                  borderStyle: "solid",
                  borderColor: "#dee2e6",
                  borderWidth: `${
                    this.props.displayTopBorder || "0px"
                  } 1px 0px 1px`,
                  padding: 10,
                  width: "100%",
                }}
              >
                <Button
                  variant={this.state.filter === "" ? "light" : "secondary"}
                  onClick={() => {
                    this.setState({ ...this.state, filter: "" });
                    refetch({
                      variables: {
                        limit: this.state.limit,
                        state: "",
                      },
                    });
                  }}
                >
                  Alle
                </Button>
                <Button
                  variant={
                    this.state.filter === "offen" ? "light" : "secondary"
                  }
                  onClick={() => {
                    this.setState({ ...this.state, filter: "offen" });
                    refetch({
                      variables: {
                        limit: this.state.limit,
                        state: this.state.filter,
                      },
                    });
                  }}
                >
                  Offene
                </Button>
                <Button
                  variant={
                    this.state.filter === "eingereicht" ? "light" : "secondary"
                  }
                  onClick={() => {
                    this.setState({ ...this.state, filter: "eingereicht" });
                    refetch({
                      variables: {
                        limit: this.state.limit,
                        state: this.state.filter,
                      },
                    });
                  }}
                >
                  Eingereichte
                </Button>
                <Button
                  variant={
                    this.state.filter === "erstattet" ? "light" : "secondary"
                  }
                  onClick={() => {
                    this.setState({ ...this.state, filter: "erstattet" });
                    refetch({
                      variables: {
                        limit: this.state.limit,
                        state: this.state.filter,
                      },
                    });
                  }}
                >
                  Erstattete
                </Button>
                <Button
                  variant={
                    this.state.filter === "einspruch" ? "light" : "secondary"
                  }
                  onClick={() => {
                    this.setState({ ...this.state, filter: "einspruch" });
                    refetch({
                      variables: {
                        limit: this.state.limit,
                        state: this.state.filter,
                      },
                    });
                  }}
                >
                  Beanstandete
                </Button>
                <Button
                  variant={
                    this.state.filter === "nachforderung"
                      ? "light"
                      : "secondary"
                  }
                  onClick={() => {
                    this.setState({ ...this.state, filter: "nachforderung" });
                    refetch({
                      variables: {
                        limit: this.state.limit,
                        state: this.state.filter,
                      },
                    });
                  }}
                >
                  Nachforderungen
                </Button>
                <Button
                  variant={
                    this.state.filter === "abgeschlossen"
                      ? "light"
                      : "secondary"
                  }
                  onClick={() => {
                    this.setState({ ...this.state, filter: "abgeschlossen" });
                    refetch({
                      variables: {
                        limit: this.state.limit,
                        state: this.state.filter,
                      },
                    });
                  }}
                >
                  Abgeschlossene
                </Button>
              </ButtonGroup>
              <div
                className="table-responsive"
                style={{
                  borderStyle: "solid",
                  borderColor: "#dee2e6",
                  borderWidth: `${
                    this.props.displayTopBorder || "0px"
                  } 1px 1px 1px`,
                  marginBottom: 100,
                  padding: 10,
                }}
              >
                <table className="table with-status table-sm table-hover middle">
                  <thead>
                    <tr>
                      <th onClick={() => this.switchSort("status")} scope="col">
                        Status&nbsp;
                        {this.state.sortKey === "status" &&
                          this.state.sortOrder === "asc" && (
                            <span className="icon-up-open fs-075 ml-1" />
                          )}
                        {this.state.sortKey === "status" &&
                          this.state.sortOrder === "desc" && (
                            <span className="icon-down-open fs-075 ml-1" />
                          )}
                        {this.state.sortKey !== "status" && (
                          <span className="icon-up-open fs-075 ml-1 grayed-out" />
                        )}
                      </th>
                      <th onClick={() => this.switchSort("number")} scope="col">
                        KVA Nr.&nbsp;
                        {this.state.sortKey === "number" &&
                          this.state.sortOrder === "asc" && (
                            <span className="icon-up-open fs-075 ml-1" />
                          )}
                        {this.state.sortKey === "number" &&
                          this.state.sortOrder === "desc" && (
                            <span className="icon-down-open fs-075 ml-1" />
                          )}
                        {this.state.sortKey !== "number" && (
                          <span className="icon-up-open fs-075 ml-1 grayed-out" />
                        )}
                      </th>
                      <th
                        onClick={() => this.switchSort("patient")}
                        scope="col"
                      >
                        Patient&nbsp;
                        {this.state.sortKey === "patient" &&
                          this.state.sortOrder === "asc" && (
                            <span className="icon-up-open fs-075 ml-1" />
                          )}
                        {this.state.sortKey === "patient" &&
                          this.state.sortOrder === "desc" && (
                            <span className="icon-down-open fs-075 ml-1" />
                          )}
                        {this.state.sortKey !== "patient" && (
                          <span className="icon-up-open fs-075 ml-1 grayed-out" />
                        )}
                      </th>
                      <th onClick={() => this.switchSort("sum")} scope="col">
                        Summe&nbsp;
                        {this.state.sortKey === "sum" &&
                          this.state.sortOrder === "asc" && (
                            <span className="icon-up-open fs-075 ml-1" />
                          )}
                        {this.state.sortKey === "sum" &&
                          this.state.sortOrder === "desc" && (
                            <span className="icon-down-open fs-075 ml-1" />
                          )}
                        {this.state.sortKey !== "sum" && (
                          <span className="icon-up-open fs-075 ml-1 grayed-out" />
                        )}
                      </th>
                      <th onClick={() => this.switchSort("submit")} scope="col">
                        E-Datum&nbsp;
                        {this.state.sortKey === "submit" &&
                          this.state.sortOrder === "asc" && (
                            <span className="icon-up-open fs-075 ml-1" />
                          )}
                        {this.state.sortKey === "submit" &&
                          this.state.sortOrder === "desc" && (
                            <span className="icon-down-open fs-075 ml-1" />
                          )}
                        {this.state.sortKey !== "submit" && (
                          <span className="icon-up-open fs-075 ml-1 grayed-out" />
                        )}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.sortProcesses(data.ocrProcesses).map((item: any) => (
                      <tr
                        className={`status--${item.state}`}
                        key={item.processNumber}
                      >
                        <td className="indicatorbg">
                          <div className="indicator" />
                          <span className={stateToIcon(item.state)} />
                          &nbsp;
                          {/* Rename Einspruch to Widerspruch */}
                          {item.state === "einspruch"
                            ? "widerspruch"
                            : item.state}
                        </td>
                        <td>
                          <Link to={`/vorgang/${item.processNumber}`}>
                            {item.processNumber}
                          </Link>
                        </td>
                        <td>{item.patient}</td>
                        <td>{item.sum.toFixed(2)}&nbsp;€</td>
                        <td>{item.submittedOn}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {content}
              </div>
            </>
          );
        }}
      </Query>
    );
  }
}
